import RecoverStep from "./recover_step";

const TEMPLATE = 'virtualization-vo-exist';

export default class ShowVoExist extends RecoverStep {

    constructor(template = TEMPLATE) {
        super(template);
    }

}
